import React,{Component} from 'react';
import { NavLink } from 'react-router-dom';
import Trends from './partials/Trends';
import Footer from './partials/Footer';

class Index extends React.Component {
   componentWillMount () {
      const script = document.createElement("script");
   
      script.src = "/assets/js/slick.min.js";
     // script.src = "/assets/js/main.js";
      script.async = true;
   
      document.body.appendChild(script);

      const script1 = document.createElement("script");
   
     // script1.src = "/assets/js/slick.min.js";
      script1.src = "/assets/js/main.js";
      script1.async = true;
   
      document.body.appendChild(script1);
    }
    constructor(props) {
    super(props);
    this.state = {
      menuOpen: false
    };
  }

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };
   render(){
 
    return(
        <div>
        <div class="main-banner homepage newhomedesign">
            <header class="navbar">
 <div className="mobile-toggle" onClick={this.toggleMenu}>

    ☰
  </div>
  <nav className={this.state.menuOpen ? "open" : ""}>
  <div class="site-login-inner">
   <a class="logo" href="javascript:void(0)">SearchFeed</a>
    <a href="#">Network</a>
    <a href="#">Community</a>
    <a href="#">Development</a>
    <a href="#">Ecosystem</a>
    <NavLink to="/providers" >Providers</NavLink>
    <NavLink to="/about" >About</NavLink>
    <a href="#">Pricing</a> </div>
  </nav>
  <div class="nav-actions">
    <button class="signin">Sign in</button>
    <button class="cta"><NavLink to="/quote" >Get a Quote</NavLink> </button>
  </div>
</header>
        
                <div class="container">
               
                <header class="main-header d-flex justify-content-between hide">
               <div class="site-logo">
                  <a href="javascript:void(0)">SearchFeed</a>
               </div>
               <div class="menu-toggle-icon">
                  <span class="hamburger-inner"></span>
               </div>
               <div class="site-login">
                  <div class="menu-toggle-bg"></div>
                  <div class="site-login-inner">
                     <div class="site-logo menu-with-logo">
                        <a href="javascript:void(0)">SearchFeed</a>
                     </div>
                      
                     <a href="/quote" className="mr-4 top-link mobi" id="get-start">Get a Quote</a>
                      <NavLink to="/signals" className="mr-4 top-link mobi" >Signals</NavLink>
                     
                     
                     <NavLink to="/signals" className="mr-4 top-link desk">Signals</NavLink>
                     <NavLink to="/careers" className="mr-4 top-link">Careers</NavLink>
                     
                     <NavLink to="/company" className="mr-4 top-link">Company</NavLink> 
                     {/* <NavLink to="/" className="mr-4 top-link desk">Login</NavLink> */}
                     <NavLink to="/quote" className="btn btn-lg btn-flat btn-outline ml-3 desk get3">Get a Quote</NavLink>
                  </div>
               </div>
            </header>

         

<section class="hero ">
  <div class="hero-content">
    <h1>Lorem Ipsum is simply dummy <br />text of the printing</h1>
    <p>Contrary to popular belief Lorem Ipsum is not simply random text</p>
<div class="cre-button">
    <div class="credit-pill">
      Get up to $100 in credits
    </div>
<br/>
    <NavLink to="/quote" className="get-started">Get a Quote</NavLink>  </div>
  </div>

  <div class="hero-image">
    <img src="assets/images/top2.png" alt="Lobster" />
  </div>
</section>


                
            <div class="row justify-content-center hideold">
               <div class="col-md-9">
               <div class="banner-content text-center">
                     <h1 class="banner-title">Lorem Ipsum is simply dummy text of the printing.</h1>
                     <div class="banner-description">
                        <p><span class="freet" >Contrary to popular belief</span> Lorem Ipsum is not simply random text</p>
                     </div>
                     <div class="banner-action" ><form action="/quote">
                     <div class="input-group">
                        
                           <input type="text" class="form-control" placeholder="Work email" required />
                     <div class="input-group-append">
                              
                     <a href="/quote" className="btn btn-lg btn-flat btn-primary">
                                  Free Account
                              <svg focusable="false" class="ibm-duo-u--link-icon--arrow-right" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" slot="icon"><path d="M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"></path></svg>
                              </a> 
                           </div>
                          
                           </div>
                           </form>
                           </div>
                     </div>
               
               
               </div> </div>
               
              
                </div>
                <section class="trusted">
  <p>Trusted by Leading Innovators</p>
  <div class="logos">
    <span><img src="assets/images/open1.png" /></span>
    <span><img src="assets/images/open2.png" /></span>
    <span><img src="assets/images/open1.png" /></span>
    <span><img src="assets/images/open2.png" /></span>
    <span><img src="assets/images/open1.png" /></span>
    
  </div>
</section>
                </div>

                <div class="call-to-action container hideold">
                <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-7">
                        <div class="pl-5">
                            <h2 class="freeh2">Lorem Ipsum </h2>
                            <p class="pclass">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <div class="buttonstart">
                        <NavLink to="/quote" className="btn btn-lg btn-flat btn-dark">Get a Quote
                        <svg focusable="false" class="ibm-duo-u--link-icon--arrow-right" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" slot="icon"><path d="M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"></path></svg>
                        </NavLink> </div>
                    </div>
                </div>
                </div>
                </div>
                
                <div class="logodiv">
                    <p>Colombian Cities that we Serve</p>
                    <div class="img-box2">
                    <img src="assets/images/SearchFeed_city1.png" alt=""  />
                </div>
                <div class="img-box2">
                    <img src="assets/images/SearchFeed_city3.png" alt=""  />
                </div>
                <div class="img-box2">
                    <img src="assets/images/SearchFeed_city2.png" alt=""  />
                </div>
                

                </div>
                
                <div class="connecting-trends first-trends">
         <div class="container">
            <div class="row align-items-center rotate-in-mobile">
            <div class="col-md-6">
            <Trends />
                     </div>
            
            
            <div class="col-md-6">
               <div class="section-content">
                <h2>What is Lorem <br />Ipsum?</h2>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                  <a href="javascript:void(0)" class="btn-link green">View All Integrations &nbsp; </a>
               </div> </div>
            </div>

            </div>
      </div>

      <div class="connecting-trends sect" >
         <div class="container">
            <div class="row align-items-center">
               <div class="col-md-6">
                  <div class="section-content">
                  <h2>What is Lorem <br />Ipsum?</h2>
                     <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                     <a href="javascript:void(0)" class="btn-link green">View All Integrations &nbsp; </a>
                  </div>
               </div>
               <div class="col-md-6">
                  <div class="logo-list">
                     <div class="row c-home-notifications">
                     
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Google marketing platform" /></div>
                        </div>
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Twitter" /></div>
                        </div>
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Braze" /></div>
                        </div>
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Google Big Query" /></div>
                        </div>
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Amazon Kinesis" /></div>
                        </div>
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Salesforce Marketing Cloud" /></div>
                        </div>
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Mix Panel" /></div>
                        </div>
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Remerge" /></div>
                        </div>
                        <div class="col-6 col-md-4">
                           <div class="logo-wrap"><img src="assets/images/facebook-logo.png" alt="Live Ramp" /></div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>

     {/*  <div class="intro-sections">
         <section class="intro-section">
            <div class="container">
               <div class="row">
                  <div class="col-md-7 revercediv">
                     <img src="assets/images/workflow-collaboration@4x-66d002b4.png" alt="placeholder-image" />
                  </div>
                  <div class="col-md-5">
                     <strong class="label">Lorem Ipsum</strong>
                     <h2>What is Lorem Ipsum?</h2>
                     <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                     <a href="javascript:void(0)" class="btn-link gray">Learn More &nbsp; </a>
                  </div>
               </div>
            </div>
         </section>
      
      </div> */}
      
      

<div class="g-call-to-action variant-compact theme-light">
    <div class="g-grid-container">
        <h2 data-testid="heading" class="g-type-display-2">What is Lorem Ipsum?</h2>
        <div class="content-and-links">
            <p data-testid="content" class="g-type-body-large">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
            <div data-testid="links" class="links">
                <a class="g-btn size-medium variant-primary background-light" data-ga-button="contact-sales" href="#"><span class="text g-type-buttons-and-standalone-links">Contact Sales</span></a>
                <a class="g-btn size-medium variant-secondary background-light" data-ga-button="request-demo" href="#"><span class="text g-type-buttons-and-standalone-links">Request Demo</span></a>
            </div>
        </div>
    </div>
</div>


   
       <Footer />

<div class="row -center hero-row popupde">
    <div class="close2">
        <a class="close-atag" href="javascript:void(0);">
            <img src="assets/images/xlose.png" />
        </a>
    </div>
<img class="feature-callout__img" src="https://luna1.co/005100.png" alt="Image of team" width="112" />
            <div class="signupForm-homepage-center col-xsmall-12 col-small-8 col-small-offset-2 col-medium-10 col-medium-offset-1 col-large-8 col-large-offset-2 col-xlarge-6 col-xlarge-offset-3">
                <h4 class="heading -spacing-2 -h3">Sign up</h4>
                <p class="subheading -spacing-1 hero-legal-copy">
                    By signing up, I agree to the Asana <a href="/terms#privacy-policy" class="css-1kfjk3x-Link">Privacy Policy</a> and <a href="/terms#terms-of-service" class="css-1kfjk3x-Link">Terms of Service</a>.
                </p>
                <form action="get-started/verify" method="get" novalidate="" class="signupForm hidden-logged-in signupForm-homepage-center" __bizdiag="1239199729" __biza="WJ__">
                    <div class="signupForm-container">
                        <div class="signupForm-row">
                        <div class="form-group">
                                
                                <input type="email" name="e" required  class="form-control" placeholder="name@company.com" id="work-email" />
                            </div>

                            <div class="submit-btn">
                                <button id="go-to-nextStep"  onClick={this.toggleBox} class="btn btn-lg btn-flat btn-block btn-primary">Next</button>
                            </div>
                        </div>
                    </div>
                </form>
                
            </div>
        </div>
    </div>
    );
}
}

export default Index;
